// class GlobalStore {
//   constructor() {
//     /**
//      * @type {GlobalState}
//      */
//     this.snapshot = {};
//   }

//   setSnapshot(snapshot) {
//     this.snapshot = snapshot;
//   }

//   setQuoteFormData(formData) {
//     this.snapshot = { ...this.snapshot, quoteFormData: { ...this.snapshot.quoteFormData, ...formData } };
//   }

//   /**
//    *
//    * @returns {GlobalState}
//    */
//   getSnapshot() {
//     return this.snapshot;
//   }

//   getQuoteFormData(appName = null) {
//     return appName ? this.snapshot[appName].quoteFormData : this.snapshot.quoteFormData;
//   }

//   getCalculatorFormData(appName = null) {
//     return appName ? this.snapshot[appName].calculatorFormData || {} : this.snapshot.calculatorFormData || {};
//   }

//   getAppFormData(appName = null) {
//     return appName ? this.snapshot[appName].appFormData : this.snapshot.appFormData;
//   }

//   getLandingPage() {
//     return this.snapshot.landingPage;
//   }

//   getCurrentProduct() {
//     return this.snapshot.currentProduct;
//   }

//   getCurrentProductCode() {
//     return this.snapshot.currentProductCode;
//   }

//   getCurrentPageCategory() {
//     return this.snapshot.currentPageCategory;
//   }

//   getCurrentPageStep() {
//     return this.snapshot.currentPageStep;
//   }
//   getIsNri() {
//     return this.snapshot.is_nri;
//   }

//   getIsAnnuityAppForm(){
//     return this.snapshot.isAnnuityAppForm;
//   }

//   getIsNri() {
//     return this.snapshot.is_nri;
//   }
// }

// export default new GlobalStore();
import { GlobalStoreInstance as GlobalStore } from "shared-library";

export default GlobalStore;
